/**************************************************************************************************************************************************
*   MODULE NAME     :  AbstractAPI
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  12-02-2021
*   DESCRIPTION     :  Abstract APIs
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG2467262
*   DESCRIPTION: <GLSD>: Node 20 Upgrade and Implement MSAL
*   DATE: 29-Jan-2025
/**************************************************************************************************************************************************/
import axios from "axios";
import ApiBase from "./ApiBase";
import config from "../config.json";

class AbstractApi {
    static response = {};
    static abstractUrl = `${config.Backend_URL}/abstract`;
    static searchUrl = `${config.Backend_URL}/search`;
    static attachmentUrl = `${config.Backend_S3_URL}/attachment`;
    static addAbstractUrl = `${config.Backend_S3_URL}/addabstract`;

    /**
     * Get All Products
     */
    static loadAllProduct = async => {
        let payload = { action: 'getMasterData', typeId: "100003", active: true }
        this.response = ApiBase.post(this.searchUrl, payload);
        return this.response;
    }

    /**
    * Get All Countries
    */
    static loadAllCountry = async () => {
        let payload = { action: 'getMasterData', typeId: "100004", active: true }
        this.response = ApiBase.post(this.searchUrl, payload);
        return this.response;
    }

    /**
     * Get All Explanations
    */
    static loadAllExplanation = async () => {
        let payload = { action: 'getMasterData', typeId: "100002", active: true }
        this.response = await ApiBase.post(this.searchUrl, payload);
        return this.response;
    }


    /**
     * Get All Status
    */
    static loadAllStatus = async () => {
        let payload = { action: 'getMasterData', typeId: "100005", active: true }
        this.response = await ApiBase.post(this.searchUrl, payload);
        return this.response;

    }

    /**
    Get Alerts Data
    
     */
    static getAlertMasterData = async () => {
        let payload = { action: 'getAlertsMasterData' }
        this.response = await ApiBase.post(this.searchUrl, payload);
        return this.response;
    }

    /**
     *  ADD ABSTRACT API
     */

    static addAbstract = async payload => {
        payload.active = true;
        payload.migrateFlag = false;
        payload.statusFlag = 0;
        payload.enblAlrtsAndVldtinsFlag = true;
        this.response = await ApiBase.post(this.addAbstractUrl, payload);
        return this.response;
    }

    static addAbstractBulk = async payload => {
        this.response = await ApiBase.post(this.abstractUrl, {abstracts: payload, action: 'addAbstractBulk'});
        return this.response;
    }

    static updateAbstract = async payload => {
        payload.action = 'updateAbstract';
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }

    static loadAllAbstractData = async (payload = {}) => {
        payload.action = 'getAllAbstract';
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }

    static loadAbstractDetail = async payload => {
        payload.action = 'getAbstract';
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }


    static lockAbstract = async payload => {
        payload.action = "lockAbstract";
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }

    static unlockAbstract = async payload => {
        payload.action = "unlockAbstract";
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }

    static loadAbstractAudit = async (abstractId) => {
        this.response =  await ApiBase.post(this.searchUrl, { action: "getAbstractAudit", abstractId});
        return this.response;
    }

    static getAbstractLockedByData = async (payload) => {
        payload.action = 'getAbstractLockedByData';
        this.response =  await ApiBase.post(this.searchUrl, payload);
        return this.response;
    }
    static getAllLockedAbstractData = async (payload = {}) => {
        payload.action = 'getAllLockedAbstractData';
        this.response =  await ApiBase.post(this.searchUrl, payload);
        return this.response;
    }

    static uploadAbstractAttachment = async(payload)=>{
        this.response = await axios.post(`${config.Backend_S3_URL}/attachment`, payload)
        return this.response;
    }

    static addOrUpdateAbstractAttachment = async(payload)=>{
        payload.action = "addOrUpdateAbstractAttachment";
        this.response = await ApiBase.post(this.abstractUrl,payload);
        return this.response;
    }

    static archiveAttachment = async(payload)=>{
        this.response = await axios.post(`${config.Backend_S3_URL}/move`, payload)
        return this.response;
    }


    static loadAbstractAttachments = async(payload)=>{
        this.response = await ApiBase.post(this.abstractUrl,payload);
        return this.response;
    }

    static loadAllAbstractDataPagination = async (payload) => {
        payload.action = 'getAllAbstractPagination';
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }

    static loadAllOrignalAbstractData = async (payload) => {
        payload.action = 'getAllOrignalAbstracts';
        this.response = await ApiBase.post(this.abstractUrl, payload);
        return this.response;
    }
}

export default AbstractApi;